import { ComponentDesignTimestamps, JackGirderConnection } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function create(connection: JackGirderConnection) {
  return DesignService.post<readonly ComponentDesignTimestamps[]>('jackGirderConnections', { data: connection });
}

export function getJacks(componentDesignGuid: string, sharedComponentSetLookupCode?: string) {
  return DesignService.get<readonly JackGirderConnection[]>(
    `componentDesigns/${componentDesignGuid}/jacks`,
    sharedComponentSetLookupCode ? { params: new URLSearchParams({ sharedComponentSetLookupCode }) } : undefined,
  );
}

export function getGirders(componentDesignGuid: string, sharedComponentSetLookupCode?: string) {
  return DesignService.get<readonly JackGirderConnection[]>(
    `componentDesigns/${componentDesignGuid}/girders`,
    sharedComponentSetLookupCode ? { params: new URLSearchParams({ sharedComponentSetLookupCode }) } : undefined,
  );
}

export function getAllForProject(projectGuid: string) {
  return DesignService.get<readonly JackGirderConnection[]>(`projects/${projectGuid}/jackGirderConnections`);
}

export function getAllInvolving(componentDesignGuids: readonly string[]) {
  return DesignService.post<readonly JackGirderConnection[]>('componentDesigns/allInvolvedJackGirderConnections', {
    data: componentDesignGuids,
  });
}

export function getAllInvolvingRecursively(componentDesignGuids: readonly string[]) {
  return DesignService.post<readonly JackGirderConnection[]>(
    'componentDesigns/allInvolvedJackGirderConnectionsRecursively',
    {
      data: componentDesignGuids,
    },
  );
}

export function remove(jackGirderConnectionGuids: string[]) {
  return DesignService.delete<readonly ComponentDesignTimestamps[]>(`jackGirderConnections`, {
    data: jackGirderConnectionGuids,
  });
}

interface RemoveAllFromGirderResponse {
  readonly removedGuids: string[];
  readonly updatedTimestamps: ComponentDesignTimestamps[];
}

export function removeAllFromGirder(girderGuid: string) {
  return DesignService.post<RemoveAllFromGirderResponse>(`jackGirderConnections/removeAllFromGirder/${girderGuid}`);
}

export function put(jackGirderConnections: JackGirderConnection[]) {
  return DesignService.put<readonly ComponentDesignTimestamps[]>('jackGirderConnections', {
    data: jackGirderConnections,
  });
}

export function insert(jackGirderConnections: JackGirderConnection[]) {
  return DesignService.put<readonly ComponentDesignTimestamps[]>('jackGirderConnections/insert', {
    data: jackGirderConnections,
  });
}
